/**
 * LGPD Block A — visible legal links.
 *
 * Small footer-style row linking to the static beta legal pages shipped in
 * ``public/legal/`` (served as plain files by the SPA nginx ``try_files``
 * rule, so no router changes are needed). Rendered on the pre-auth screens
 * (login and invite acceptance) — the surfaces every user passes through.
 *
 * The pages themselves are beta drafts and say so explicitly; this
 * component makes no compliance claim.
 *
 * LGPD Block B adds a "Preferências de privacidade" entry that reopens the
 * consent dialog (see shared/consent).
 */

import { openConsentPreferences } from '@/shared/consent'

const LEGAL_LINKS = [
  { href: '/legal/privacidade.html', label: 'Política de Privacidade' },
  { href: '/legal/termos.html', label: 'Termos de Uso' },
  { href: '/legal/politica-dados-beta.html', label: 'Política de Dados do Beta' },
  { href: '/legal/contato-privacidade.html', label: 'Contato de Privacidade' },
] as const

export function LegalLinks() {
  return (
    <nav
      aria-label="Links legais"
      data-testid="legal-links"
      className="flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] leading-relaxed text-text-dim"
    >
      {LEGAL_LINKS.map((link, index) => (
        <span key={link.href} className="flex items-center gap-x-3">
          {index > 0 ? <span aria-hidden="true">·</span> : null}
          <a
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="underline-offset-2 transition-colors duration-150 hover:text-text-soft hover:underline"
          >
            {link.label}
          </a>
        </span>
      ))}
      <span className="flex items-center gap-x-3">
        <span aria-hidden="true">·</span>
        <button
          type="button"
          data-testid="legal-consent-preferences"
          onClick={openConsentPreferences}
          className="underline-offset-2 transition-colors duration-150 hover:text-text-soft hover:underline"
        >
          Preferências de privacidade
        </button>
      </span>
    </nav>
  )
}
